import type { PricingCompanySize } from '@recruitee/pricing-types';
import { PricingCompanySizeE } from '@recruitee/pricing-types';
import type { BillingPlan } from '@recruitee/products-types';
import { BillingPlanTier } from '@recruitee/products-types';

import { ProductStatus } from '../plan-picker.types';

const LegacyTiers = [BillingPlanTier.Launch, BillingPlanTier.Scale, BillingPlanTier.Lead];
const ProductTierOrder = [BillingPlanTier.Start, BillingPlanTier.Grow, BillingPlanTier.Optimize];

const getSelfServiceProductStatus = (activeProduct?: BillingPlan, targetProduct?: BillingPlan) => {
  if (!targetProduct) {
    return ProductStatus.ManualService;
  }

  if (!activeProduct) {
    return ProductStatus.SelfService;
  }

  if (activeProduct.custom && targetProduct?.id !== activeProduct.id) {
    return ProductStatus.Unavailable;
  }

  if (activeProduct.tier === targetProduct.tier) {
    if (activeProduct.billingPeriod === targetProduct.billingPeriod) {
      return ProductStatus.Owned;
    } else {
      return ProductStatus.TierOwned;
    }
  }

  if (LegacyTiers.includes(activeProduct.tier)) {
    return ProductStatus.SelfService;
  }

  const activePlanIndex = ProductTierOrder.indexOf(activeProduct.tier);
  const targetPlanIndex = ProductTierOrder.indexOf(targetProduct.tier);

  if (activePlanIndex < targetPlanIndex) {
    return ProductStatus.SelfServiceUpgrade;
  }

  if (activePlanIndex > targetPlanIndex) {
    return ProductStatus.SelfServiceDowngrade;
  }

  return ProductStatus.SelfService;
};

export const getManualProductStatus = (
  activeProduct?: BillingPlan,
  targetProduct?: BillingPlan,
) => {
  if (!activeProduct) {
    return ProductStatus.ManualService;
  }

  if (targetProduct && activeProduct.id === targetProduct.id) {
    return ProductStatus.ManualServiceOwned;
  }

  return ProductStatus.ManualService;
};

export const getPlanPicker2024ProductStatus = (
  isSelfService: boolean,
  activeProduct?: BillingPlan,
  targetProduct?: BillingPlan,
  companySize?: PricingCompanySize,
): ProductStatus => {
  if (companySize === PricingCompanySizeE['151+']) {
    return ProductStatus.ManualService;
  }

  return isSelfService
    ? getSelfServiceProductStatus(activeProduct, targetProduct)
    : getManualProductStatus(activeProduct, targetProduct);
};
